import {
  ApplicationConfig,
  importProvidersFrom,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
  provideZonelessChangeDetection,
} from '@angular/core';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import {
  provideRouter,
  withComponentInputBinding,
  withViewTransitions,
} from '@angular/router';

import { DATE_PIPE_DEFAULT_OPTIONS } from '@angular/common';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { APIRouteMap } from '@core/models/api';
import { ScreenSizeService } from '@core/services';
import {
  imageInterceptor,
  INTERCEPTOR_CONFIG,
  langInitializer,
} from '@core/utils';
import { environment } from '@environment';
import { provideTranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import {
  ajaxHeaderInterceptor,
  AUTH_SERVICE,
  baseUrlInterceptor,
  errorInterceptor,
  loggingInterceptor,
} from '@paypoint-frontend/web-core';
import { routes } from './app.routes';
import { AppService } from './app.service';
import { AuthService } from './core/services/auth';

export const appConfig: ApplicationConfig = {
  providers: [
    { provide: AUTH_SERVICE, useExisting: AuthService },
    // { provide: TOKEN_SERVICE, useExisting: TokenService },
    // { provide: LANG_SERVICE, useExisting: LANG_SERVICE },

    provideBrowserGlobalErrorListeners(),
    provideZonelessChangeDetection(),
    provideRouter(routes, withViewTransitions(), withComponentInputBinding()),
    provideHttpClient(
      withInterceptors([
        baseUrlInterceptor(
          environment,
          INTERCEPTOR_CONFIG.baseUrlInterceptor.skipUrls,
        ),
        errorInterceptor,
        ajaxHeaderInterceptor(
          INTERCEPTOR_CONFIG.ajaxHeaderInterceptor.skipUrls,
        ),
        // jwtInterceptor(INTERCEPTOR_CONFIG.jwtInterceptor.skipUrls),
        loggingInterceptor,
        imageInterceptor(),
      ]),
    ),
    provideTranslateService({
      loader: provideTranslateHttpLoader({
        prefix: `${APIRouteMap.CONTENT_GETTRANSLATES}/`,
        suffix: '',
      }),
    }),
    importProvidersFrom([]),
    provideAppInitializer(langInitializer),
    provideAnimationsAsync(),
    ScreenSizeService,
    AppService,
    {
      provide: DATE_PIPE_DEFAULT_OPTIONS,
      useValue: {
        dateFormat: 'dd.MM.yyyy HH:mm:ss',
      },
    },
  ],
};
